export default {
  getPropertyAddress: state => {
    return state.propertyAddress;
  },
  getEstimateDetails: state => {
    return state.estimateDetails;
  },
  getErrors: state => {
    return state.errors;
  }
};
